import { useEffect, useState } from "react";
import { humanize } from "../../../utils/words";

function CarrierSearch({ selectedCarrier, setSelectedCarrier, carriers }) {
  const [filteredCarriers, setFilteredCarriers] = useState([])

  useEffect(() => {
    setFilteredCarriers(carriers);
  }, [carriers])

  const handleCarrierSearch = (e) => {
    const searchInput = e.target.value;
    const currentCarriers = carriers;

    const result = currentCarriers.filter((item) => {
      const label = item.id.toLowerCase()
      if (label.includes(searchInput.toLowerCase())) return true;
      return false;
    })

    setFilteredCarriers(result);
  }

  return (
    <>
      <input className="carrier-search-input" placeholder="Carrier Search" onChange={handleCarrierSearch} />
      <div className="carrier-search-results">
        {filteredCarriers.map((carrier) => {
          return (
            <span
              key={carrier.id}
              onClick={() => setSelectedCarrier(carrier.id)}
              className={selectedCarrier === carrier.id && `active`}
            >
              {humanize(carrier.name)}
            </span>
          );
        })}
      </div>
    </>
  );
}

export default CarrierSearch;
